import { render, staticRenderFns } from "./NewRirekishoReasonCard.vue?vue&type=template&id=730d748b"
import script from "./NewRirekishoReasonCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoReasonCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports